export default __webpack_public_path__ + "static/media/logo-21-hcc-hotels.75ed4303.png";